import React from 'react';

// Custom vector process diagram: 6 steps, navy connector line, gold numbered markers.
const STEPS = [
  { n: 1, title: 'Opportunity introduction' },
  { n: 2, title: 'Preliminary review' },
  { n: 3, title: 'Product & documentation evaluation' },
  { n: 4, title: 'Commercial discussion' },
  { n: 5, title: 'Account onboarding' },
  { n: 6, title: 'Purchase & relationship management' },
];

export const ProcessDiagram = ({ steps = STEPS }) => {
  return (
    <div data-testid="process-diagram">
      {/* Desktop / tablet horizontal */}
      <ol className="hidden md:grid grid-cols-6 gap-0 relative">
        <div className="absolute left-0 right-0 top-6 h-px bg-ophir-grey" aria-hidden="true" />
        <div className="absolute left-0 top-6 h-px bg-ophir-gold" style={{ width: '100%' }} aria-hidden="true" />
        {steps.map((s) => (
          <li key={s.n} className="relative flex flex-col items-center text-center px-2">
            <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-white border-2 border-ophir-gold text-ophir-navy font-serif text-lg font-bold shadow-ophir">
              {s.n}
            </span>
            <h3 className="mt-4 text-[15px] font-semibold text-ophir-navy leading-snug">{s.title}</h3>
            {s.body && <p className="mt-1 text-[13px] text-ophir-muted leading-relaxed">{s.body}</p>}
          </li>
        ))}
      </ol>
      {/* Mobile vertical */}
      <ol className="md:hidden relative pl-6">
        <div className="absolute left-[11px] top-2 bottom-2 w-px bg-ophir-gold" aria-hidden="true" />
        {steps.map((s) => (
          <li key={s.n} className="relative pb-7 last:pb-0">
            <span className="absolute -left-6 flex h-6 w-6 items-center justify-center rounded-full bg-white border-2 border-ophir-gold text-ophir-navy text-[12px] font-bold">
              {s.n}
            </span>
            <h3 className="text-[15px] font-semibold text-ophir-navy">{s.title}</h3>
            {s.body && <p className="mt-1 text-[14px] text-ophir-muted leading-relaxed">{s.body}</p>}
          </li>
        ))}
      </ol>
    </div>
  );
};
